// Announces the Mac Printer Driver to Mac users on landing (ENG-3479).
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Modal } from 'antd';
import { AppleLogo, DownloadSimple, Printer } from '@phosphor-icons/react';

import MacPrintDialog from '../../assets/img/mac_print_dialog.png';
import { openPrinterDriverDownload } from '../../util/printerDriverDownload';
import { dismissMacPrinterDriverAnnouncement } from '../../util/macPrinterDriverAnnouncement';
import { captureAnalytics } from '../../actions/preload';
import './macPrinterDriverAnnouncement.scss';

class MacPrinterDriverAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = { doNotShowAgain: true };
  }

  // Every way out (Close, the X, the mask, installing) honours the checkbox.
  close = () => {
    const { hideModal } = this.props;
    const { doNotShowAgain } = this.state;
    if (doNotShowAgain) dismissMacPrinterDriverAnnouncement();
    hideModal();
  };

  install = () => {
    captureAnalytics('mac_printer_driver_announcement_download_clicked');
    openPrinterDriverDownload();
    this.close();
  };

  render() {
    const { doNotShowAgain } = this.state;

    // Passed as the antd title (not body content) so antd labels the dialog
    // with it; screen readers announce this when focus enters.
    const title = (
      <>
        <div className="mac-printer-announcement-hero">
          <div className="mac-printer-announcement-icon">
            <Printer size={24} weight="fill" />
          </div>
          <span className="mac-printer-announcement-badge">
            <AppleLogo size={12} weight="fill" />
            New for Mac
          </span>
        </div>
        <h2 className="mac-printer-announcement-title">
          The Medsender Printer Driver is now available for Mac
        </h2>
      </>
    );

    return (
      <Modal
        visible
        width={480}
        footer={null}
        onCancel={this.close}
        wrapClassName="mac-printer-announcement"
        title={title}
      >
        <p className="mac-printer-announcement-text">
          Install Medsender as a printer on your Mac (macOS 12 or later). Then press &#8984;P in any
          app and choose
          {' '}
          <strong>Medsender File Printer</strong>
          {' '}
          to send the file straight to Medsender.
        </p>
        <div className="mac-printer-announcement-preview">
          <img
            src={MacPrintDialog}
            alt="Mac print dialog with Medsender File Printer selected as the printer"
          />
        </div>
        <button type="button" className="mac-printer-announcement-cta" onClick={this.install}>
          <DownloadSimple size={18} weight="bold" />
          Download for Mac
        </button>
        <div className="mac-printer-announcement-footer">
          <Checkbox
            checked={doNotShowAgain}
            onChange={(event) => this.setState({ doNotShowAgain: event.target.checked })}
          >
            Don&apos;t show this to me again
          </Checkbox>
          <button type="button" className="mac-printer-announcement-close" onClick={this.close}>
            Close
          </button>
        </div>
      </Modal>
    );
  }
}

MacPrinterDriverAnnouncement.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default MacPrinterDriverAnnouncement;
